import clsx from 'clsx';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { ShouldRender } from '../shared/basic/ShouldRender';

interface ResourcesFixedHeaderProps {
  links: { text: string; route: string }[];
  isShort?: boolean;
  heading: string;
}

const Header: React.FC<ResourcesFixedHeaderProps> = ({ links, heading }) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => {
      const productsContainer = document.getElementById('products');
      const resourcesContainer = document.getElementById('resources-container');

      if (!productsContainer || !resourcesContainer) return;

      const productsContainerBottom =
        productsContainer.offsetTop + productsContainer.offsetHeight;
      const scrollY = window?.scrollY;

      if (scrollY > productsContainerBottom) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window?.addEventListener('scroll', handleScroll);

    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <header
        className={`${
          isScrolled ? 'fixed top-14  left-0 right-0 ' : ''
        } bg-dropDownMenuBg py-3 md:py-5 transition-transform  w-full md:px-4 lg:px-24 z-20 `}
      >
        <div className={clsx(' mx-auto flex items-center w-full ')}>
          <nav className='flex h-full items-center w-full px-5 md:px-0 text-sm overflow-auto no-scrollbar'>
            <span
              onClick={() => router.push('/product')}
              className='flex font-medium group items-center cursor-pointer'
            >
              <span
                className={clsx(
                  router.pathname === '/product' ||
                    router.pathname === '/product/'
                    ? 'text-white'
                    : 'text-[#77777C]',
                  ' uppercase text-[10px] md:text-base  font-bold',
                )}
              >
                {heading}
              </span>
            </span>
            <span className='h-3 bg-[#FFFFFF33] mx-4 md:mx-8 w-[1px]'></span>

            <div className=' h-4 text-[#77777C] font-semibold  flex justify-center items-center' />
            {links.map(
              (
                link: { text: string; route: string | undefined },
                index: number,
              ) => (
                <span
                  key={`${link.route}-${index}`}
                  onClick={() => {
                    link.route && router.push(link.route);
                  }}
                  className={clsx(
                    link.route && router.asPath.includes(link.route)
                      ? 'text-white'
                      : 'text-[#77777C]',
                    'flex items-center font-semibold uppercase  hover:text-white  cursor-pointer',
                  )}
                >
                  <span className='text-[10px] md:text-base'>{link.text}</span>
                  <ShouldRender check={index !== links.length - 1}>
                    <span className='h-3 bg-[#FFFFFF33] mx-4 md:mx-8 w-[1px]'></span>
                  </ShouldRender>
                </span>
              ),
            )}

            <div
              style={{
                background:
                  'linear-gradient(180deg, rgba(83, 255, 90, 0.2) 0%, rgba(57, 132, 244, 0.2) 100%)',
              }}
              className='px-2.5 rounded-full italic ml-3 py-1 text-xs font-bold'
            >
              <span
                style={{
                  background:
                    'linear-gradient(180deg, #53FF5A 0%, #3984F4 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Bestseller
              </span>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
